<template>
  <CockpitDialog
    title="应急组织机构"
    @close="() => $emit('close')"
    left="630px"
    width="890px"
    height="550px"
    top="120px"
  >
    <div class="flex h-full pt-10px">
      <div class="w-270px">
        <categoryTitle class="mb-10px" title="应急组织机构" />
        <div class="h-[calc(100%-38px)]">
          <div class="ml-16px mr-8px h-full">
            <el-input
              placeholder="组织名称"
              v-model="keyword"
              size="small"
              clearable
              @keypress.enter.native="searchTreeData()"
              class="icon-search__input mb-10px"
            >
              <i
                slot="append"
                class="el-icon-search cursor-pointer icon-search__input"
                @click="searchTreeData()"
              ></i>
            </el-input>
            <el-tree
              ref="orgRef"
              :data="superiorDepartmentList"
              :props="defaultTreeProps"
              highlight-current
              :filter-node-method="filterTreeNode"
              @node-click="selectHandler"
              :expand-on-click-node="false"
              :default-expand-all="true"
              class="text-14px mt-10px tree-wrap h-[calc(100%-46px)] pt-5px"
            >
              <span slot-scope="{ data }">
                <span :title="data.name" class="text-hex-fff">{{ data.name }}</span>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
      <div class="flex-1 pl-8px h-full table-wrap">
        <categoryTitle class="mb-10px" title="应急组织成员" />
        <div class="h-[calc(100%-38px)]">
          <div class="mb-10px">
            <el-input v-model="userName" placeholder="人员名称" clearable class="mr-10px !w-50" />
            <el-select
              v-model="makeUpExam"
              size="small"
              class="mr-10px !w-50"
              placeholder="定位状态"
              clearable
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-button type="primary" size="mini" @click="goSearch">搜索</el-button> -->
            <button
              class="handle_btn search !inline-block"
              size="small"
              type="button"
              @click="goSearch"
            >
              搜索
            </button>
          </div>
          <div class="h-[calc(100%-48px)]">
            <el-table :data="showData" highlight-current-row height="100%" ref="tableRef">
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column
                label="人员名称"
                prop="userName"
                min-width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="角色"
                prop="roleName"
                min-width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="联系方式"
                prop="userMobilePhoneNo"
                min-width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="定位状态"
                prop="examCode"
                min-width="120"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  <div :class="row.isLine ? 'text-hex-11d45f' : 'text-hex-fc0f0f'">
                    {{ row.isLine ? '在线' : '离线' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="{ row }">
                  <div
                    v-if="row.isLine"
                    @click="goPoint(row)"
                    class="cursor-pointer text-hex-00bcc8"
                  >
                    定位
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
// components
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import { OrganizationApi, EmployeeApi } from '@wiz-api/emergency-management'
import { PersonnelApi, TagApi } from '@wiz-api/personnel-position'
// import PersonnelList from './personnal'

const organizationApi = new OrganizationApi()
const employeeApi = new EmployeeApi()
const personnelApi = new PersonnelApi()
const tagApi = new TagApi()

export default {
  components: { CockpitDialog, CategoryTitle },
  data() {
    return {
      page: {
        pageSize: 15,
        pageNo: 1,
        total: 0,
      },
      keyword: '',
      userName: '',
      organizationName: '',
      makeUpExam: '',
      defaultTreeProps: {
        children: 'children',
        label: 'name',
        code: 'id',
      },
      statusList: [
        { label: '在线', value: true },
        { label: '离线', value: false },
      ],
      superiorDepartmentList: [],
      tableList: [],
      tableLoading: false,
      personnelList: [],
      ws: '',
      realData: [], // 实时定位
      timer: '',
      showData: [],
    }
  },
  computed: {
    modelSetting() {
      return Wiz.globalSettings.dynamicModules.modules['visualization-cockpit-tongre'].config
    },
  },
  methods: {
    // 过滤树节点
    searchTreeData() {
      this.$refs.orgRef.filter(this.keyword)
    },
    /**
     * @description: 搜索区域树
     * @param {*} value
     * @param {*} data
     * @return {*}
     */
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    /**
     * @description 获取上级部门下拉框数据
     */
    async getSuperiorDepartmentList() {
      const [err, res] = await organizationApi.getTree({
        showDefault: true,
      })
      if (!err) {
        this.superiorDepartmentList = [
          {
            children: res.items,
            name: '应急组织机构',
            id: '0',
          },
        ]
      }
    },
    goSearch() {
      this.page.pageNo = 1
      this.getTableData()
    },
    // 组织人员列表
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await employeeApi.getList({
        skipCount: 0,
        maxResultCount: 999,
        userName: this.userName,
        organizationName: this.organizationName,
      })
      this.tableLoading = false
      if (!err) {
        res.items.forEach((item) => {
          const info = this.personnelList.find((val) => {
            return val.id === item.userID
          })
          item.tagCode = info ? info.tagCode : ''
        })
        this.tableList = res.items
        this.page.total = res.totalCount
        this.dealData()
      }
    },
    // 获取标签人员列表
    async getPersonnelList() {
      const [err, res] = await personnelApi.getPersonnelPostionList({
        isBind: true,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err) {
        this.personnelList = res
      }
    },
    // 过滤在线离线
    filterData() {
      this.tableList.forEach((item) => {
        const info = this.realData.find((val) => {
          return val.tagCode === item.tagId
        })
        if (info) {
          item.isLine = true
          item.pos = { x: info.x, y: info.y, z: info.z }
        } else {
          item.isLine = false
        }
      })
      if (typeof this.makeUpExam === 'boolean') {
        this.showData = this.tableList.filter((item) => {
          return item.isLine === this.makeUpExam
        })
      } else {
        this.showData = this.tableList
      }
    },
    // 筛选数据
    dealData() {
      this.filterData()
      const self = this
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(() => {
        self.filterData()
      }, 5000)
    },
    // 连接ws
    openWebSocketClient() {
      if (this.ws) {
        this.ws.close()
      }
      const socketUrl =
        `${this.modelSetting?.emergencyDisposalConfig.webSocketUrl}/Position?modelId=3a0f5919-b640-f2f2-30e6-323c5865e1d3&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230`
      // 'ws://devaspnetcore02.wiz.top:4547/Position?modelId=3a0f5919-b640-f2f2-30e6-323c5865e1d3&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230'
      this.ws = new WebSocket(socketUrl)

      // ws.readyState===0 正在建立连接还没有连接
      // ws.readyState===1 连接成功，可以send数据
      // ws.readyState===2 正在关闭，还没有关闭
      // ws.readyState===3 连接已关闭，或不能打开
      // 监听连接是否成功
      this.ws.onopen = () => {}
      // 接收服务器信息
      this.ws.onmessage = (data) => {
        const msg = JSON.parse(data.data)
        this.realData = msg.onLineList || []
      }
      // 监听连接关闭时间
      this.ws.onclose = () => {}
      // 监听并处理错误事件
      this.ws.onerror = (error) => {
        if (this.ws.readyState === 3) {
          // this.$message.error('无法获取人员实时信息')
        }
      }
    },

    // 定位
    async goPoint(row) {
      // 跟随人员
      await this.cloudRender.PosViewer.setPerspectiveFollow({
        id: row.tagCode,
        personalPerspective: 2,
        angle: [5, 90],
      })
      // const openEvent = new CustomEvent('openComponent', {
      //   detail: {
      //     toCom: {
      //       code: 'PersonnelInfo',
      //       origin: 'tag',
      //       name: '人员信息',
      //       originTagName: 'PersonnelList',
      //     },
      //     type: 'tags',
      //     props: {
      //       personnelId,
      //       tagCode,
      //     },
      //   },
      // })
      // window.dispatchEvent(openEvent)
    },
    selectHandler(data) {
      this.organizationName = data.id === '0' ? '' : data.name
      this.getTableData()
    },
  },
  async created() {
    await this.getPersonnelList()
    this.getSuperiorDepartmentList()
    this.getTableData()
    this.openWebSocketClient()
  },

  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    player: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #4dc2d2;
  }
}
.search {
  background: #4dc2d2;
}
.handle_btn[disabled] {
  cursor: no-drop;
}
.tree-wrap {
  border: 1px solid #45f2eb33;
  background-color: #184c5c4c;
}
.table-wrap {
  border-left: 1px solid #2f7075;
}
</style>
